import { render, staticRenderFns } from "./VerticalDynamicForm.vue?vue&type=template&id=30b9dffc"
import script from "./VerticalDynamicForm.vue?vue&type=script&lang=js"
export * from "./VerticalDynamicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports